import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgLock24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 6.75C9.75 5.50736 10.7574 4.5 12 4.5C13.2426 4.5 14.25 5.50736 14.25 6.75V9.75H9.75V6.75ZM8.25 9.75H8C6.89543 9.75 6 10.6454 6 11.75V17.5C6 18.6046 6.89543 19.5 8 19.5H16C17.1046 19.5 18 18.6046 18 17.5V11.75C18 10.6454 17.1046 9.75 16 9.75H15.75V6.75C15.75 4.67893 14.0711 3 12 3C9.92893 3 8.25 4.67893 8.25 6.75V9.75Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=Lock24.svg.js.map
